<app-loading-bar></app-loading-bar>
<router-outlet></router-outlet>
<app-snackbar-host></app-snackbar-host>

